import React from "react"
import { Link } from 'react-router-dom';
import vitalSourceLogo from "../../img/vst_logo_signin.svg";
import supportLogo from "../../img/circle_support.svg";
import "../../styles/LoginForm.css";
import LoginContainer from "../containers/LoginContainer";
import { Icon } from "@vitalsource/vstui";
import externalTabIcon from "../../img/new-external-tab.svg";
import {Calendar, XSmall} from "@vitalsource/vstui-icons";
import Styled from "styled-components"

const CustomXSmall = Styled(XSmall)`
  pointer-events: none;
`;

export interface LoginFormProps {
}

const LoginForm = (props: LoginFormProps) => {
  return (
    <div className={"login"}>
      <div className={"login__layout"}>
        <LoginContainer />
        <div className="login-bottom-bar">
          <span className="login-strapline">Powered by<img className="login-strapline-img" src={vitalSourceLogo}/></span>
          <span className="login-support">
            <a className="support-link" target="_blank"
               href="https://success.vitalsource.com/hc/en-us/categories/23251248756503-Studio">
              <img className="login-support-img" src={supportLogo}/><span>Support</span>
            </a>
          </span>
        </div>
      </div>
    </div>
  )
}

export default LoginForm;
